import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

export class SetUpFormErrors {
    ERROR_EMAIL_INVALID: boolean;
    ERROR_EMAIL_EXISTS: boolean;
    ERROR_DOMAIN_INVALID: boolean;
    ERROR_NO_PLUS_CHAR: boolean;
    WARNING_DOMAIN_IS_ENTERPRISE: boolean;
    ERROR_PENDING_VERIFICATION: boolean;
}

export class CompanyDetailsFormErrors {}

export class RegisterValidateFormData {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    override_domain_is_enterprise_warning: boolean;
}

export class RegisterCompanyFormData {
    organisation: string;
    num_staff: number;
    country_id: number;  // 1 = AU, 2 = EU, 3 = CA, 4 = US
    password: string;
}

export class RegisterFormData {
    user_details: RegisterValidateFormData;
    company_details: RegisterCompanyFormData;
    default_locale: string;
}

@Injectable({
    providedIn: 'root'
})
export class RegisterService {
    url = `${environment.AUTH_API}`;

    setUpFormErrors = new SetUpFormErrors();

    constructor(
        private http: HttpClient
    ) {}

    setRegionalUrl(region: string) {
        if (region && region.toLowerCase() !== 'au') {
            const originalUrl = environment.AUTH_API;
            const api = originalUrl.slice(0, originalUrl.indexOf('.'));
            const domain = originalUrl.slice(originalUrl.indexOf('.') + 1);

            this.url = `${api}-${region}.${domain}`;

        } else {
            this.url = environment.AUTH_API;
        }
    }

    validateSetUp(formData: RegisterValidateFormData) {
        return this.http.post(`${this.url}registration/user-details-validate`, formData).pipe((data) => data);
    }

    register(formData: RegisterFormData) {
        return this.http.post(`${this.url}registration/register`, formData).pipe((data) => data);
    }

    getNumStaffOptions() {
        return this.http.get(`${this.url}registration/num-staff`).pipe((data) => data);
    }

    getCountryDetails() {
        return this.http.get(`${this.url}registration/countries`).pipe((data) => data);
    }

    getRegionCurrency() {
        return this.http.get(`${this.url}registration/data-locales`).pipe((data) => data);
    }

    verifyAccount(token: any) {
        return this.http.post(`${this.url}registration/user-verify`, {token}).pipe((data) => data);
    }

    resendLinkByEmail(email: string) {
        return this.http.post(`${this.url}registration/resend-verification-link/email`, {email}).pipe((data) => data);
    }

    resendLinkByToken(token: string) {
        return this.http.post(`${this.url}registration/resend-verification-link/token`, {token}).pipe((data) => data);
    }

    registerLead(email: string) {
        return this.http.post(`${this.url}registration/register-lead`, { email: email }).pipe((data) => data);
    }
}
